<template>
    <div class="animated fadeIn bgV2">
        <b-row>
            <b-col md="12">   
                <gofix-tab
                    class="mt-3 ContractCaseSettings"
                    :data="contract_tab"
                    :query-param="{id:$route.params.id}"
                    activeKey="case-settings"
                    arrows >
                    <template slot="gofixTab:case-settings">
                        <div class="px-4 py-3 d-flex align-items-center switch-module">
                            <b-form-group class="mb-0">
                                <b-form-radio-group
                                    id="radio-group-1"
                                    class="requestor-radio"
                                    v-model="case_module"
                                    :options="[
                                        { text: 'Generic', value: 'Generic' },
                                        { text: 'Hot button', value: 'Hot-Button' }
                                    ]"
                                    name="radio-options"
                                ></b-form-radio-group>
                            </b-form-group>
                            <gofix-button label="SET" outline :loading="loading" @click="checkExistCase"></gofix-button>
                        </div>
                        <template v-if="ClientContractID && ClientContractID.case_setting_module">
                            <template v-if="ClientContractID.case_setting_module == 'Generic'">
                                <gofix-tab
                                    class="mt-3 contractPropertyChildTab"
                                    classTabContent="border-none box-shadow-none"
                                    :data="tabDataChild"
                                    showFullTab>
                                    <template slot="gofixTab:general">
                                        <General />
                                    </template>
                                    <template slot="gofixTab:requester_type">
                                        <RequesterType />
                                    </template>
                                    <template slot="gofixTab:requestor_company">
                                        <RequestorCompanies />
                                    </template>
                                    <template slot="gofixTab:nature_of_feedback">
                                        <NatureOfFeedback />
                                    </template>
                                    <template slot="gofixTab:activity">
                                        <Activity />
                                    </template>
                                    <template slot="gofixTab:tags_case_info">
                                        <TagsCaseInfo />
                                    </template>
                                    <template slot="gofixTab:tags_case_requestor">
                                        <TagsCaseRequestor />
                                    </template>
                                    <template slot="gofixTab:custom_fields">
                                        <CustomFields />
                                    </template>
                                </gofix-tab>
                            </template>
                            <template v-if="ClientContractID.case_setting_module == 'Hot-Button'">
                                <gofix-tab
                                    class="mt-3 contractPropertyChildTab"
                                    classTabContent="border-none box-shadow-none"
                                    :data="tabDataChildHB"
                                    showFullTab>
                                    <template slot="gofixTab:general">
                                        <GeneralCaseHotButton />
                                    </template>
                                    <template slot="gofixTab:activity">
                                        <ActivityCaseHotButton />
                                    </template>
                                    <template slot="gofixTab:nature_of_feedback">
                                        <NatureOfFeedback />
                                    </template>
                                    <template slot="gofixTab:pic_role_mapping">
                                        <PICRoleMappingCaseHotButton />
                                    </template>
                                </gofix-tab>
                            </template>
                        </template>
                        <!-- <RequesterType />
                        <NatureOfFeedback /> -->
                    </template>
                </gofix-tab>
            </b-col>
        </b-row>
    </div>
</template>
<script>
    import tabData from '@/data/_tabs';
    const RequesterType = () => import('./requester-type.vue')
    const NatureOfFeedback = () => import('./nature-of-feedback.vue')
    const Activity = () => import('./activity.vue')
    const TagsCaseRequestor = () => import('./tags/case-requestor.vue')
    const TagsCaseInfo = () => import('./tags/case-info.vue')
    const CustomFields = () => import('./custom-fields.vue')
    const General = () => import('./general.vue')
    const RequestorCompanies = () => import('./requestor-companies.vue')
    // Case Hot Button
    const GeneralCaseHotButton = () => import('./case-hot-button/general.vue')
    const ActivityCaseHotButton = () => import('./case-hot-button/activity.vue')
    const PICRoleMappingCaseHotButton = () => import('./case-hot-button/pic_role_mapping.vue')
    import { mapGetters } from 'vuex';
    export default {
        name: 'contract-case-settings',
        components: {
            RequesterType,
            NatureOfFeedback,
            Activity,
            TagsCaseRequestor,
            TagsCaseInfo,
            CustomFields,
            General,
            RequestorCompanies,
            GeneralCaseHotButton,
            ActivityCaseHotButton,
            PICRoleMappingCaseHotButton
        },
        data () {
            return {
                contract_tab: tabData.client_contract,
                tabDataChild:[
                    {
                        key: "general",
                        title: "General",
                        active: true
                    },
                    {
                        key: "requester_type",
                        title: "Requestor Type",
                        active: false
                    },
                    {
                        key: "requestor_company",
                        title: "Requestor Company",
                        active: false
                    },
                    {
                        key: "nature_of_feedback",
                        title: "Nature Of Feedback",
                        active: false
                    },
                    {
                        key: "activity",
                        title: "Activity",
                        active: false
                    },
                    {
                        key: "tags_case_info",
                        title: "Tags - Case Info",
                        active: false
                    },
                    {
                        key: "tags_case_requestor",
                        title: "Tags - Case Requestor",
                        active: false
                    },
                    {
                        key: "custom_fields",
                        title: "Custom Fields",
                        active: false
                    }
                ],
                tabDataChildHB:[
                    {
                        key: "general",
                        title: "General",
                        active: true
                    },
                    {
                        key: "activity",
                        title: "Activity",
                        active: false
                    },
                    {
                        key: "nature_of_feedback",
                        title: "Nature Of Feedback",
                        active: false
                    },
                    {
                        key: "pic_role_mapping",
                        title: "PIC Role Mapping",
                        active: false
                    },
                ],
                loading: false,
                timer: null,
                case_module: 'Generic'
            }
        },
        computed: {
            ...mapGetters({
                ClientContractID: 'ContractController/ClientContractID',
            }),
        },
        watch: {
            ClientContractID: function(val) {
                if(val && val.id) {
                    this.case_module = val.case_setting_module
                } else {
                    this.case_module = 'Generic'
                }
            }
        },
        created() {
            if(this.ClientContractID && this.ClientContractID.id) {
                    this.case_module = this.ClientContractID.case_setting_module
                } else {
                    this.case_module = 'Generic'
                }
        },
        methods:{
            checkExistCase() {
                if (this.timer) {
                    clearTimeout(this.timer);
                    this.timer = null;
                }
                this.timer = setTimeout(async () => {
                    if(this.ClientContractID.case_setting_module != this.case_module) {
                        this.loading = true;
                        if(this.case_module == 'Generic') {
                            this.$store.dispatch("CaseHotButtonController/getList", {
                                page: 1,
                                limit: 1,
                                isCMS: 1,
                                filter: {
                                    client_contract_id: { type:"number", value: this.ClientContractID.id, function:"=", with:[] }
                                }
                            })
                            .then(response => {
                                if(response.data.data && response.data.data.items && response.data.data.items.length) {
                                    this.loading = false;
                                    this.$alertNotification('Switching is not allowed as there are existing cases. Please contact administrator.', 'danger');
                                } else {
                                    this.setCaseModule()
                                }
                            })
                            .catch(err => {})
                            return
                        }

                        if(this.case_module == 'Hot-Button') {
                            this.$store.dispatch("CaseManagementController/getList", {
                                page: 1,
                                limit: 1,
                                filter: {
                                    client_contract_id: this.ClientContractID.id
                                }
                            })
                            .then(response => {
                                if(response.data.data && response.data.data.items && response.data.data.items.length) {
                                    this.loading = false;
                                    this.$alertNotification('Switching is not allowed as there are existing cases. Please contact administrator.', 'danger');
                                } else {
                                    this.setCaseModule()
                                }
                            })
                            .catch(err => {})
                            return
                        }
                    }
                }, 200);
            },
            setCaseModule() {
                let objClone = {
                    contract_id: this.ClientContractID.id,
                    client_id: this.ClientContractID.client_id,
                    supplier_id: this.ClientContractID.supplier_id,
                    contract_name: this.ClientContractID.contract_name,
                    abbreviation: this.ClientContractID.abbreviation,
                    description: this.ClientContractID.description,
                    deposit_amount: this.ClientContractID.deposit_amount,
                    issuing_bank: this.ClientContractID.issuing_bank,
                    deposit_expiry: this.ClientContractID.deposit_expiry,
                    insurance_expiry: this.ClientContractID.insurance_expiry,
                    insurance_excess: this.ClientContractID.insurance_excess,
                    insurance_type: this.ClientContractID.insurance_type,
                    timezone: this.ClientContractID.timezone,
                    settings: this.ClientContractID.settings,
                    case_setting_module: this.case_module
                }
                
                if(!this.ClientContractID.case_hot_button_settings) {
                    objClone.case_hot_button_settings = JSON.stringify({
                        prefill_fm_officer_in_charge_case_creator: true,
                        require_user_to_select_the_last_node_of_service_category: true,
                        detect_existing_cases_of_the_same_property: false,
                        hot_button_tracking_frequency: '',
                    })
                }

                objClone.settings = JSON.stringify(objClone.settings);
                this.$store.dispatch('ContractController/UpdateClientContract', objClone)
                .then(response => {
                    this.loading = false;
                    this.$store.dispatch('ContractController/getClientContractID', objClone.contract_id);
                    this.$alertNotification(this.$notificationV2('editing', 'client_contract_setting'));
                })
                .catch(error => {
                    this.loading = false;
                });
            }
        }
    }
</script>
<style lang="scss">
    .switch-module {
        .custom-control {
            padding-right: 1.5rem;
        }
    }
    
</style>
